module.exports = __webpack_public_path__ + "img/banner2.f9fefe72.jpg";